import { render, staticRenderFns } from "./packingScreen.vue?vue&type=template&id=09b49278&scoped=true&"
import script from "./packingScreen.vue?vue&type=script&lang=js&"
export * from "./packingScreen.vue?vue&type=script&lang=js&"
import style0 from "./packingScreen.vue?vue&type=style&index=0&id=09b49278&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b49278",
  null
  
)

export default component.exports